import { render, staticRenderFns } from "./general-dropdown.vue?vue&type=template&id=5479df55&scoped=true&"
import script from "./general-dropdown.vue?vue&type=script&lang=js&"
export * from "./general-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./general-dropdown.vue?vue&type=style&index=0&id=5479df55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5479df55",
  null
  
)

export default component.exports